import { render, staticRenderFns } from "./EditStatusDialog.vue?vue&type=template&id=8825acee&scoped=true"
import script from "./EditStatusDialog.vue?vue&type=script&lang=js"
export * from "./EditStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8825acee",
  null
  
)

export default component.exports